(function(){
  const productPageRequest = window.location.pathname.includes("/products/");
  const shopNavItem = document.querySelector('[data-link-name="shop"]');
  if (productPageRequest) shopNavItem.classList.add("site-nav--active")
})();

// Lightbox click-to-zoom v3 — custom overlay
(function() {
  var overlay, overlayImg, overlayClose;

  function buildOverlay() {
    if (document.getElementById('pc-zoom-overlay')) return;
    overlay = document.createElement('div');
    overlay.id = 'pc-zoom-overlay';
    overlayClose = document.createElement('button');
    overlayClose.id = 'pc-zoom-close';
    overlayClose.innerHTML = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="4"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>';
    overlayClose.setAttribute('aria-label', 'Close');
    overlayImg = document.createElement('img');
    overlay.appendChild(overlayClose);
    overlay.appendChild(overlayImg);
    document.body.appendChild(overlay);
    overlayClose.addEventListener('click', closeZoom);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeZoom();
    });
  }

  function openZoom(src, rx, ry) {
    overlay.classList.add('pz-active');
    overlayImg.src = src;
    overlayImg.onload = function() {
      var sw = overlayImg.naturalWidth;
      var sh = overlayImg.naturalHeight;
      overlay.scrollLeft = sw * rx - window.innerWidth / 2;
      overlay.scrollTop = Math.max(0, sh * ry - window.innerHeight / 2);
    };
  }

  function closeZoom() {
    overlay.classList.remove('pz-active');
  }

  function initZoom(lb) {
    var img = lb.querySelector('.pclb-img');
    if (!img || img._zoomAttached) return;
    img._zoomAttached = true;
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      var rect = img.getBoundingClientRect();
      var rx = (e.clientX - rect.left) / rect.width;
      var ry = (e.clientY - rect.top) / rect.height;
      openZoom(img.src, rx, ry);
    });
  }

  function watchLightbox(lb) {
    new MutationObserver(function() {
      if (lb.classList.contains('pclb-open')) {
        setTimeout(function() {
          var img = lb.querySelector('.pclb-img');
          if (img) img._zoomAttached = false;
          initZoom(lb);
        }, 150);
      } else {
        closeZoom();
      }
    }).observe(lb, { attributes: true, attributeFilter: ['class'] });
  }

  buildOverlay();

  var lb = document.getElementById('pc-lightbox');
  if (lb) {
    watchLightbox(lb);
  } else {
    new MutationObserver(function(mutations, observer) {
      var lb = document.getElementById('pc-lightbox');
      if (lb) {
        observer.disconnect();
        watchLightbox(lb);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();